import { IsArray, IsInt } from 'class-validator';

export class NomenclatureTypeFieldSortRequest {
    @IsArray()
    @IsInt({ each: true })
    public nomenclatureTypeFieldIds: number[] = [];

    constructor(data?: Partial<NomenclatureTypeFieldSortRequest>) {
        this.nomenclatureTypeFieldIds = data?.nomenclatureTypeFieldIds ?? [];
    }
}
